module.exports = __webpack_public_path__ + "static/media/add-relationship-icon.389988ac.svg";